<template>
  <div>
    <div class="jc-page-header">
      <h1>
        {{title}}
        <slot name="card-head"></slot>
      </h1>
      <div class="jc-box-action">
        <slot name="card-message"><a :href="linkAddress" target="_blank">{{linkMessage}}</a></slot>
        <slot name="card-tail"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sk-card',
  props: {
    title: {
      // 标题
      require: true
    },
    linkAddress: {
      // 跳转地址
      type: String
    },
    linkMessage: {
      // 跳转说明
      type: String
    }
  },
  components: {},
  mixins: [],
  data() {
    return {}
  },
  mounted() {},
  created() {},
  watch: {},
  computed: {},
  filters: {},
  methods: {}
}
</script>
